import { render, staticRenderFns } from "./comment-base.vue?vue&type=template&id=52cd7587&scoped=true"
import script from "./comment-base.vue?vue&type=script&lang=js"
export * from "./comment-base.vue?vue&type=script&lang=js"
import style0 from "./comment-base.vue?vue&type=style&index=0&id=52cd7587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd7587",
  null
  
)

export default component.exports